<template>
  <div class="d-flex align-items-center mb-2" v-if="positionLeft || positionLeft == null">
    <div class="symbol  symbol-35px symbol-circle ">
      <img
          class="symbol-label"
          :src="$getImage(user?.avatar)"
          alt=""
          v-if="user?.avatar"
      />
      <img
          src="@/assets/images/MotTruyen_LogoApp1.png"
          alt=""
          v-else
      />
    </div><!--end::Avatar-->
    <!--begin::Details-->
    <div class="ms-3">
      <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">{{user == null ? 'Không xác định' : user.name }}</a>
    </div>
    <!--end::Details-->
  </div>
  <div class="d-flex align-items-center mb-2" v-else>
    <!--begin::Details-->
    <div class="me-3">
      <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">{{user == null ? 'Không xác định' : user.name }}</a>
    </div>
    <!--end::Details-->

    <!--begin::Avatar-->
    <div class="symbol  symbol-35px symbol-circle ">
      <img
          class="symbol-label"
          :src="$getImage(user?.avatar)"
          alt=""
          v-if="user?.avatar"
      />
      <img
          src="@/assets/images/MotTruyen_LogoApp1.png"
          alt=""
          v-else
      />
    </div><!--end::Avatar-->
  </div>
    <!--end::Info-->
</template>

<script>
export default {
  name: 'UserCardSimple',
  props: {
    user: {
      type: Object,
      required: false,
    },
    positionLeft: {
      type: Object,
      required: false,
    },
    isAdmin: {
      type: Object,
      required: false,
    },
  },
};
</script>
